import { createFileRoute } from "@tanstack/react-router";
import { newsArticles } from "@/pages/Nieuws";
import Nieuws from "@/pages/Nieuws";

export const Route = createFileRoute("/nieuws/")({
  head: () => ({
    meta: [
      { title: "Nieuws – De Hussel App" },
      { name: "description", content: "Het laatste nieuws over De Hussel App. Updates, nieuwe features en nieuws uit de tenniswereld." },
      { property: "og:title", content: "Nieuws – De Hussel App" },
      { property: "og:description", content: "Het laatste nieuws over De Hussel App. Updates, nieuwe features en nieuws uit de tenniswereld." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/nieuws" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/nieuws" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Nieuws – De Hussel App",
          url: "https://dehusselapp.nl/nieuws",
          description:
            "Het laatste nieuws over De Hussel App. Updates, nieuwe features en nieuws uit de tenniswereld.",
          mainEntity: {
            "@type": "ItemList",
            itemListElement: newsArticles.map((a, i) => ({
              "@type": "ListItem",
              position: i + 1,
              url: `https://dehusselapp.nl/nieuws/${a.slug}`,
            })),
          },
        }),
      },
    ],
  }),
  component: Nieuws,
});
